import React from 'react';

interface PriceDisplayProps {
  price: number;
  originalPrice?: number;
  discountedPrice?: number;
  className?: string;
  showDiscountPercentage?: boolean;
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  price,
  originalPrice,
  discountedPrice,
  className = '',
  showDiscountPercentage = true
}) => {
  // Determine which prices to display
  const hasDiscount = originalPrice && discountedPrice && originalPrice > discountedPrice;
  const displayPrice = hasDiscount ? discountedPrice : price;
  const discountPercentage = hasDiscount 
    ? Math.round(((originalPrice! - discountedPrice!) / originalPrice!) * 100)
    : 0;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {hasDiscount ? (
        <>
          {/* Discounted Price */}
          <span className="text-base sm:text-lg font-bold text-primary-600 dark:text-primary-400">
            ₹{displayPrice!.toLocaleString()}
          </span>
          
          {/* Original Price (strikethrough) */}
          <span className="text-sm text-gray-500 dark:text-gray-400 line-through">
            ₹{originalPrice!.toLocaleString()}
          </span>
          
          {/* Discount Percentage */}
          {showDiscountPercentage && discountPercentage > 0 && (
            <span className="text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 px-2 py-1 rounded-full font-medium">
              {discountPercentage}% OFF
            </span>
          )}
        </>
      ) : (
        /* Regular Price */
        <span className="text-base sm:text-lg font-bold text-primary-600 dark:text-primary-400">
          ₹{displayPrice.toLocaleString()}
        </span>
      )}
    </div>
  );
};

export default PriceDisplay;